import { Component, inject } from '@angular/core';
import { PreviouslyPurchasedProductListConfigService } from '../../services/previously-purchased-product-list-config/previously-purchased-product-list-config.service';
import { ProductListV2Component } from '../product-list-v2/product-list-v2.component';

@Component({
  selector: 'lib-previously-purchased-product-list',
  templateUrl: './previously-purchased-product-list.component.html',
  styleUrl: './previously-purchased-product-list.component.scss',
  standalone: false
})
export class PreviouslyPurchasedProductListComponent extends ProductListV2Component {
  public productListConfigService = inject(PreviouslyPurchasedProductListConfigService);
}
